import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <g>
      <path
        fill={ fill }
        d="M18 24H3c-1.65 0-3-1.35-3-3V6h2v15c0 .55.45 1 1 1h15v2z"
      />
      <path
        fill={ fill }
        d="M22 0H8C6.9 0 6 .9 6 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-3 10h-3v3h-2v-3h-3V8h3V5h2v3h3v2z"
      />
    </g>
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
